import { meanBy, round, sortBy, sumBy } from 'lodash';
import { Measurement } from './measurement';
import { IDateValue } from './types';

/**
 * Should have all of the data to display a point:
 * its aggregate value
 * and all of the measurements that make it up for hover over stuff
 */
export class DateSummary implements IDateValue {
  public dateString: string;
  private measurements: Measurement[];
  private aggregateType: 'sum' | 'average' | 'mostRecent' | 'averageAndRound';

  constructor(
    dateString: string,
    measurements: Measurement[],
    aggregateType: 'sum' | 'average' | 'mostRecent' | 'averageAndRound'
  ) {
    this.dateString = dateString;
    this.measurements = measurements;
    this.aggregateType = aggregateType;
  }

  get date(): Date {
    return new Date(this.dateString);
  }

  get value(): number {
    if (this.aggregateType === 'sum') {
      return this.sum();
    } else if (this.aggregateType === 'average') {
      return this.average();
    } else if (this.aggregateType === 'mostRecent') {
      return this.mostRecent();
    } else if (this.aggregateType === 'averageAndRound') {
      return this.averageAndRound();
    } else {
      throw new Error('Unknown aggregate type');
    }
  }

  public average(): number {
    return meanBy(this.measurements, meas => meas.value);
  }

  public averageAndRound(): number {
    return round(meanBy(this.measurements, meas => meas.value));
  }

  public sum(): number {
    return sumBy(this.measurements, meas => meas.value);
  }

  public mostRecent(): number {
    const mostRecentMeasurement = sortBy(this.measurements, meas => meas.date).pop();
    if (!mostRecentMeasurement) {
      throw new Error('Most Recent Measurement should not be empty');
    } else {
      return mostRecentMeasurement.value;
    }
  }
}
